import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0238',
    ecrans: ['00-2'],
    params: ['?vaetypfnd',
             '?cleintdet']
});
